module.exports = __webpack_public_path__ + "static/hero-hcp-dosing-mobile-ade408d8e5bd8ca5effc10bff465514f.png";